<ng-container *ngIf="barVm$ | async; let vm">
	<div class="bar">
		<!-- Search -->
		<div class="search-wrap">
			<svg
				class="search-icon"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				stroke-width="2">
				<circle cx="11" cy="11" r="8" />
				<path d="m21 21-4.35-4.35" />
			</svg>
			<input
				class="search-input"
				type="text"
				placeholder="Rechercher…"
				i18n-placeholder="@@general.search.placeholder"
				[value]="vm.filterState.search"
				(input)="setSearch($any($event.target).value)" />
			<!-- Only rendered while there is something to clear; the gutter it sits
			     in is reserved either way. -->
			<button
				*ngIf="vm.filterState.search"
				class="search-clear"
				type="button"
				title="Effacer la recherche"
				i18n-title="@@general.search.clear"
				(click)="setSearch('')">
				<mat-icon fontIcon="close"></mat-icon>
			</button>
		</div>

		<!-- Grouping tags trigger (selected chips render below the bar) -->
		<ng-container *ngIf="tagFilterVisible && availableTags.length > 0">
			<span class="sep"></span>

			<div class="group tags-group">
				<span class="group-label">
					<span i18n="@@project.grouping-tags.label">Tags de Domaine</span>
				</span>

				<!-- Dropdown -->
				<ng-container *ngIf="dropdownVm$ | async; let dd">
					<div class="dropdown-wrap">
						<button
							#kwTrigger
							class="btn-add-kw"
							type="button"
							[class.btn-add-kw--open]="dd.open"
							(click)="toggleDropdown($event)">
							+
							<span i18n="@@project.grouping-tags.add">tag</span>
						</button>

						<ng-container *ngIf="dd.open">
							<div
								class="dropdown-panel"
								[style.top.px]="dd.top"
								[style.left.px]="dd.left"
								(click)="onDropdownPanelClick($event)">
								<input
									class="typeahead-input"
									type="text"
									placeholder="Filtrer les tags…"
									i18n-placeholder="@@project.grouping-tags.filter"
									autofocus
									[value]="dd.query"
									(input)="typeaheadQuery$.next($any($event.target).value)" />
								<ul class="tag-list" role="listbox">
									<ng-container *ngIf="dd.tags.length === 0">
										<li
											class="tag-option tag-option--empty"
											i18n="@@project.grouping-tags.none">
											Aucun tag de domaine disponible
										</li>
									</ng-container>
									<ng-container *ngFor="let tag of dd.tags">
										<li
											class="tag-option"
											role="option"
											(click)="selectTag(tag, $event)">
											{{ tagLabel(tag) }}
										</li>
									</ng-container>
								</ul>
							</div>
						</ng-container>
					</div>
				</ng-container>
			</div>
		</ng-container>

		<span class="sep"></span>

		<!-- Favourites -->
		<div class="group">
			<button
				type="button"
				class="toggle-btn"
				[class.toggle-btn--active]="vm.filterState.favoritesOnly"
				[class.toggle-btn--suspended]="!vm.filterState.filtersEnabled"
				[attr.aria-pressed]="vm.filterState.favoritesOnly"
				(click)="svc.toggleFavoritesOnly()">
				<!-- fontIcon must be a static attribute: mat-icon renders the
				     ligature through content: attr(fontIcon), which a property
				     binding never writes. -->
				<mat-icon
					*ngIf="vm.filterState.favoritesOnly"
					fontIcon="favorite"></mat-icon>
				<mat-icon
					*ngIf="!vm.filterState.favoritesOnly"
					fontIcon="favorite_border"></mat-icon>
				<span i18n="@@project.filter.favorites">Favoris</span>
			</button>
		</div>

		<span class="sep"></span>

		<!-- Sort -->
		<div class="group">
			<span class="group-label">
				<span i18n="@@general.action.sort.action">tri</span>
			</span>

			<div class="sort-wrap">
				<select
					class="sort-select"
					(change)="svc.setSortBy($any($event.target).value)">
					<option
						value="date-desc"
						[selected]="vm.filterState.sortBy === 'date-desc'">
						<span i18n="@@general.action.sort.date.recent">Plus récent</span>
					</option>
					<option
						value="date-asc"
						[selected]="vm.filterState.sortBy === 'date-asc'">
						<span i18n="@@general.action.sort.date.old">Plus ancien</span>
					</option>
					<option
						value="title-asc"
						[selected]="vm.filterState.sortBy === 'title-asc'">
						<span i18n="@@general.action.sort.title">Titre</span>
						A → Z
					</option>
					<option
						value="title-desc"
						[selected]="vm.filterState.sortBy === 'title-desc'">
						<span i18n="@@general.action.sort.title">Titre</span>
						Z → A
					</option>
				</select>
				<svg
					class="sort-arrow"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-width="2.5">
					<path d="m6 9 6 6 6-6" />
				</svg>
			</div>
		</div>

		<span class="sep"></span>

		<!-- Grouping-tag selector: on or off. Off is the plain card list, with
		     no tag filtering and no lanes. -->
		<div class="group">
			<div class="view-switch" role="group">
				<button
					*ngIf="folderViewVisible"
					type="button"
					class="view-switch__btn"
					[class.view-switch__btn--active]="
						vm.filterState.viewMode === 'folders'
					"
					[attr.aria-pressed]="vm.filterState.viewMode === 'folders'"
					(click)="svc.setViewMode('folders')">
					<mat-icon fontIcon="folder"></mat-icon>
					<span i18n="@@project.view.folders">Dossiers</span>
				</button>
				<button
					type="button"
					class="view-switch__btn"
					[class.view-switch__btn--active]="
						vm.filterState.viewMode === 'groups'
					"
					[attr.aria-pressed]="vm.filterState.viewMode === 'groups'"
					(click)="toggleDock(vm.filterState.viewMode)">
					<!-- Folder, not a tag: projectCard.html marks grouping tags with
					     far fa-folder and plain keyword tags with far fa-tag. Open,
					     because this reveals the drawer of them. -->
					<mat-icon fontIcon="folder_open"></mat-icon>
					<span i18n="@@project.dock.toggle">Tags de Domaine</span>
				</button>
			</div>
		</div>

		<span class="sep"></span>

		<!-- Card layout. Independent of the dock: the lanes are cut from every
		     grouping tag in the catalogue when the dock is off, and from its
		     selection when it is on. -->
		<div class="group">
			<span class="group-label">
				<span i18n="@@project.display.label">affichage</span>
			</span>

			<div class="view-switch" role="group">
				<button
					type="button"
					class="view-switch__btn"
					[class.view-switch__btn--active]="
						vm.filterState.displayMode === 'flat'
					"
					[attr.aria-pressed]="vm.filterState.displayMode === 'flat'"
					(click)="svc.setDisplayMode('flat')">
					<mat-icon fontIcon="view_module"></mat-icon>
					<span i18n="@@project.display.flat">Liste</span>
				</button>
				<button
					type="button"
					class="view-switch__btn"
					[class.view-switch__btn--active]="
						vm.filterState.displayMode === 'tag'
					"
					[attr.aria-pressed]="vm.filterState.displayMode === 'tag'"
					(click)="svc.setDisplayMode('tag')">
					<!-- The lanes are cut by grouping tag, so this carries the card's
					     grouping-tag mark, far fa-folder. -->
					<mat-icon fontIcon="folder"></mat-icon>
					<span i18n="@@project.display.tag">Par Domaine</span>
				</button>
			</div>
		</div>

		<button
			class="clear-btn suspend-btn"
			[class.clear-btn--is-disabled]="!vm.hasActiveFilters"
			[class.suspend-btn--suspended]="!vm.filterState.filtersEnabled"
			[disabled]="!vm.hasActiveFilters"
			(click)="svc.toggleFiltersEnabled()"
			type="button">
			<ng-container *ngIf="vm.filterState.filtersEnabled">
				<mat-icon fontIcon="pause_circle"></mat-icon>
				<span i18n="@@general.action.filters.suspend">Suspendre</span>
			</ng-container>
			<ng-container *ngIf="!vm.filterState.filtersEnabled">
				<mat-icon fontIcon="play_circle"></mat-icon>
				<span i18n="@@general.action.filters.resume">Réactiver</span>
			</ng-container>
		</button>

		<button
			class="clear-btn"
			[class.clear-btn--is-disabled]="!vm.hasActiveFilters"
			[disabled]="!vm.hasActiveFilters"
			(click)="svc.clearAll()"
			type="button">
			<mat-icon fontIcon="filter_alt_off"></mat-icon>
			<span i18n="@@general.action.reset">Effacer</span>
		</button>
	</div>

	<!-- Selected grouping tag chips — wrapping row below the bar -->
	<ng-container *ngIf="tagFilterVisible && vm.selectedTags.length > 0">
		<div
			class="chips-row"
			[class.chips-row--suspended]="!vm.filterState.filtersEnabled">
			<ng-container *ngFor="let tag of vm.selectedTags">
				<span class="chip--selected">
					{{ tagLabel(tag) }}
					<button
						class="chip__remove"
						type="button"
						(click)="removeTag(tag, $event)"
						[attr.aria-label]="'Retirer ' + tagLabel(tag)">
						×
					</button>
				</span>
			</ng-container>
		</div>
	</ng-container>
</ng-container>

<ng-container *ngIf="resultsVm$ | async; let r">
	<p class="results">
		<span class="results__hits">{{ r.filtered }}&nbsp;</span>
		<span i18n="@@general.result.of">sur</span>
		{{ r.total }}
		<ng-container *ngIf="r.kind === 'folders'">
			<span i18n="@@project.results.groups">groups</span>
		</ng-container>
		<ng-container *ngIf="r.kind === 'projects'">
			<span i18n="@@project.results.projects">projets</span>
		</ng-container>
	</p>
</ng-container>
